// extracted by mini-css-extract-plugin
export var contrastLow = "_2b-1";
export var externalLink = "_2b-2";
export var externalLinkIcon = "_2b-3";
export var link = "_2b-0";
export var linkLabel = "_2b-4";